import { FeedbackImage, ScrollToTop, NavigationHeader, Footer } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';
import { useNavigate } from 'react-router-dom';
import { appRoute } from '@utils/globalConstant';

export function NotFound() {
  const navigate = useNavigate();

  // Const
  const headerContent = tA11y('nc_404_page_hdl1');
  const copyTextContent = tA11y('nc_404_page_hdl2');
  const buttonContent = tA11y('ek_404_page_btn');
  const contentIcon = useCmsImage('ek_404_web_content1');

  return (
    <>
      <ScrollToTop>
        <NavigationHeader />
        <FeedbackImage
          image={contentIcon}
          icon={appIconsPath.ONLINE}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonText="Zurück zur Übersicht"
          buttonType={appButtonType.PRIMARY}
          buttonClick={() => {
            navigate(appRoute.HOME_PAGE);
          }}
        />
        <Footer />
      </ScrollToTop>
    </>
  );
}

export default NotFound;
